import { GROUP_ID_DELIMITER } from "helpers/door-collection";
import { DimensionsPanelReduxState } from "../dimensions-panel";

export const getInitialState = (): DimensionsPanelReduxState => {
    return {
        showDoors: false,
        attributes: [],
        metrics: {
            values: [],
            showAssortmentTotals: false,
            showAssortmentPlan: false,
        },
        dimensions: [],
        collapsedGroupIds: [],
        delimiter: GROUP_ID_DELIMITER,
    };
};
